import Cookies from "js-cookie";
import { get } from "@/api/common";

// 待办统计轮询定时器（模块级，跨 action 调用持有，guard 防重复启动）
let pendingStatTimer = null;
// 5 分钟轮询一次
const PENDING_STAT_INTERVAL = 1000 * 60 * 5;
const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  device: "desktop",
  unreadCount: 0,
  // 待办统计：驱动菜单红点、铃铛数字、通知中心红点
  pendingStat: {
    sampleReviewPending: 0,
    promotionReviewPending: 0,
    quotationReviewPending: 0,
    unreadMessageCount: 0,
    reviewResultUnread: 0
  }
};
const mutations = {
  TOGGLE_SIDEBAR: State => {
    const StateClone = State;
    StateClone.sidebar.opened = !StateClone.sidebar.opened;
    StateClone.sidebar.withoutAnimation = false;
    if (StateClone.sidebar.opened) {
      Cookies.set("sidebarStatus", 1);
    } else {
      Cookies.set("sidebarStatus", 0);
    }
  },
  CLOSE_SIDEBAR: (State, withoutAnimation) => {
    const StateClone = State;
    Cookies.set("sidebarStatus", 0);
    StateClone.sidebar.opened = false;
    StateClone.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (State, device) => {
    const StateClone = State;
    StateClone.device = device;
  },
  SET_UNREAD_COUNT: (State, unreadCount) => {
    const StateClone = State;
    StateClone.unreadCount = unreadCount;
  },
  SET_PENDING_STAT: (State, payload) => {
    const StateClone = State;
    StateClone.pendingStat = {
      ...StateClone.pendingStat,
      ...payload
    };
  }
};
const actions = {
  toggleSideBar({
    commit
  }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar({
    commit
  }, {
    withoutAnimation
  }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({
    commit
  }, device) {
    commit("TOGGLE_DEVICE", device);
  },
  setUnreadCount({
    commit
  }, unreadCount) {
    commit("SET_UNREAD_COUNT", unreadCount);
  },
  // 请求待办统计接口并写入 store
  async fetchPendingStat({
    commit
  }) {
    const res = await get("/stat/pending");
    if (res && res.code === 0 && res.data) {
      const d = res.data;
      commit("SET_PENDING_STAT", {
        sampleReviewPending: d.sample_review_pending || 0,
        promotionReviewPending: d.promotion_review_pending || 0,
        quotationReviewPending: d.quotation_review_pending || 0,
        unreadMessageCount: d.unread_message_count || 0,
        reviewResultUnread: d.review_result_unread || 0
      });
    }
  },
  // 首次立即请求，成功后每 5 分钟刷新；guard 防重复启动
  startPendingStatPolling({
    dispatch
  }) {
    if (pendingStatTimer) {
      return;
    }
    dispatch("fetchPendingStat");
    pendingStatTimer = setInterval(() => {
      dispatch("fetchPendingStat");
    }, PENDING_STAT_INTERVAL);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};